import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { SwUpdate } from '@angular/service-worker';
import { Browser } from '@capacitor/browser';
import { Capacitor } from '@capacitor/core';
import { appConfig } from 'src/app/config/app.config';
import { Business } from 'src/app/models/Businesses';
import { AuthService } from 'src/app/services/auth.service';
import { BackEndService } from 'src/app/services/backEnd.service';
import { FirebaseOtpService } from 'src/app/services/firebase-otp.service';
import { LocalDbService } from 'src/app/services/localDb.service';
import { BusinessService } from 'src/app/services/modelService/business.service';
import { TranslateService } from 'src/app/services/translate.service';
import { VaniService } from 'src/app/services/vani.service';
import { VersionService } from 'src/app/services/version.service';
import { AlertService } from 'src/app/util/alert.service';
import { LoaderService } from 'src/app/util/loader.service';
import { ToastService } from 'src/app/util/toast.service';
import { UtilityTs } from 'src/app/util/utilityTs';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-slide2',
  templateUrl: './slide2.component.html',
  styleUrls: ['./slide2.component.scss'],
})
export class Slide2Component implements OnInit {


  businessList: Business[] = [];
  envName: string = environment.envName;
  version: number = VersionService.version;
  @ViewChild('myFile') fileElement: ElementRef;
  languageList: any[] = [
    { value: "en", name: "English" },
    { value: "hi", name: "Hindi" },
  ]
  selectedLang = "en";
  @Input() invitee: any;
  inviteLink: string = '';
  onCommunityChange(event: any) {
    console.log('Selected Community:', event);
    this.localDB.localPost('sub_community', event);
    this.localDB.localPost('business', this.auth.business);
    console.log('business', this.auth.business);
  }

  constructor(public auth: AuthService, private toast: ToastService,
    private translateService: TranslateService,
    private swUpdate: SwUpdate, private backEnd: BackEndService,
    public trans: TranslateService, private alert: AlertService,
    public businessService: BusinessService, private route: Router,
    private localDB: LocalDbService, private vani: VaniService,
  ) { }

  ngOnInit() {
    this.businessService.business_request;
    // console.log("Data checking ", this.auth.business, this.invitee);
    if (this.invitee) {
      this.auth.subCommunity = this.invitee.sub_community;
    }
    this.getBusinessList();
  }

  getBusinessList() {
    this.backEnd.searchObject(appConfig.STORAGE_TABLE.BUSINESS, []).then((businessList: Business[]) => {
      // Guard: if server returns null/401 (user not logged in), don't crash
      if (!businessList || !Array.isArray(businessList)) {
        console.warn('Business list not available (possibly unauthenticated). Will retry or show empty.');
        this.businessList = [];
        return;
      }
      UtilityTs.sortStringInObject(businessList, "name");
      for (let biz of businessList) {
        if (biz.category && typeof biz.category === 'string') {
          try { biz.category = JSON.parse(biz.category); } catch (e) { }
        }
      }
      this.businessList = businessList;
      setTimeout(() => {
        if (this.auth.business && this.auth.business.id) {
          this.vani.read("Verify your community, by selecting your Gotra");
        } else {
          this.vani.read("Select your community");
        }
      }, 500);
    })
  }

  changeLang(value) {
    this.selectedLang = value;
    console.log(this.selectedLang);
    this.translateService.setLanguage(value);
  }
  clickVersion() {
    if (this.swUpdate.isEnabled) {
      this.swUpdate.activateUpdate().then(() => {
        document.location.reload();
        window.location.replace(window.location.href);
      });
    } else {
      window.location.replace(window.location.href);
    }
  }


  clickCreateNewCommunity() {
    this.alert.showAlert(this.trans.translate("Create New Community"), this.trans.translate("Have you thoroughly checked your community name is not present in existing list?. If yes then add your own community"), this.trans.translate("Yes"), this.trans.translate("No")).then(() => {
      this.businessService.business_request = { status: "Requested" };
    });
  }

  clickBizName(biz: Business) {
    if (typeof biz.category === 'string' || biz.category instanceof String) {
      biz.category = JSON.parse(biz.category + "");
    }
    this.auth.business = biz;
    this.vani.read("Verify your community by selecting sub community");
  }

  clickChangeCommunity() {
    this.alert.showAlert(
      this.trans.translate('Change Community name'),
      this.trans.translate('Are you sure you want to change community name?')
    ).then(() => {
      this.businessService.business_request = null;
      this.auth.business = {} as Business;
    });
  }

  onSearchEnter(event: any) {
    let searchValue = '';

    if (typeof event === 'string') {
      searchValue = event;
    } else if (event?.target?.value) {
      searchValue = event.target.value;
    }

    if (!searchValue) {
      this.toast.error(this.trans.translate("Please enter an invite link!"));
      return;
    }

    this.inviteLink = searchValue;
    this.onInviteLinkChange(this.inviteLink);
  }
  onInviteLinkChange(link) {
    this.inviteLink = link;
    if (this.isValidInviteLink(link)) {
      const data = this.extractParams(link);
      if (data?.inviteId) {
        this.openInvite(data.inviteId, data.empId);
        this.toast.success(this.trans.translate("Invite link detected — redirecting..."));
      } else {
        this.toast.error(this.trans.translate("Invalid invite link format!"));
      }
    }
  }

  afterUpload($event) {
    console.log($event);
    this.auth.business.logo = $event;
  }

  isValidInviteLink(url: string): boolean {
    return (
      url.includes("localhost:8100/register") ||
      url.includes("dev-vanshavali.web.app/register") ||
      url.includes("vanshavali.web.app/register")
    );
  }

  extractParams(url: string) {
    const cleanUrl = url.split("/register/")[1];
    if (!cleanUrl) return null;

    const parts = cleanUrl.split("/");
    return {
      inviteId: parts[0],
      empId: parts[1] ?? null
    };
  }

  openInvite(inviteId: string, empId?: string) {
    if (inviteId) {
      if (empId) this.route.navigate([`/register/${inviteId}/${empId}`]);
      else this.route.navigate([`/register/${inviteId}`]);
    }
  }

  createYourFamilyTree() {
    const vanshavaliBusiness = this.businessList.find(b => b.id === 'Vanshavali');
    if (vanshavaliBusiness) {
      if (typeof vanshavaliBusiness.category === 'string' || vanshavaliBusiness.category instanceof String) {
        try {
          vanshavaliBusiness.category = JSON.parse(vanshavaliBusiness.category + "");
        } catch (e) {
          console.error("Error parsing business category", e);
        }
      }
      this.auth.business = vanshavaliBusiness;
      this.vani.read(this.trans.translate("Now please select your Gotra or Sub Community to continue"));
    } else {
      this.toast.error(this.trans.translate("Default community 'Vanshavali' not found. Please contact support."));
    }
  }
}